export default "__VITE_ASSET__3841fefd__"